
const digest = '2e2faec4ce3829588adb53695fb35edac85ba0539ba48b217a95157abd8de3a2';
const classes = {"wrapper":"_wrapper_1agty_1","checkbox":"_checkbox_1agty_7","title":"_title_1agty_13","groupTitle":"_groupTitle_1agty_17","patientWrapper":"_patientWrapper_1agty_25","content":"_content_1agty_38","subtitle":"_subtitle_1agty_50","toggleMore":"_toggleMore_1agty_58"};
const css = `._wrapper_1agty_1 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}
._wrapper_1agty_1 ._checkbox_1agty_7 {
  min-width: 20px;
  min-height: 20px;
  max-width: 20px;
  max-height: 20px;
}
._wrapper_1agty_1 ._title_1agty_13 {
  font-size: 14px;
}

._groupTitle_1agty_17 {
  text-transform: uppercase;
  color: #9ea0a5;
  letter-spacing: 2px;
  font-size: 12px;
  padding: 10px 24px;
}

._patientWrapper_1agty_25 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: flex-start;
}
._patientWrapper_1agty_25 ._checkbox_1agty_7 {
  min-width: 20px;
  min-height: 20px;
  max-width: 20px;
  max-height: 20px;
}
._patientWrapper_1agty_25 ._content_1agty_38 {
  display: flex;
  flex-direction: column;
}
._patientWrapper_1agty_25 ._content_1agty_38 ._title_1agty_13 {
  font-family: Rubik, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #1452ac;
  text-decoration: underline;
  line-height: normal;
}
._patientWrapper_1agty_25 ._content_1agty_38 ._subtitle_1agty_50 {
  font-size: 12px;
  font-weight: 400;
  color: #787c88;
  margin-top: 5px;
  line-height: normal;
}

._toggleMore_1agty_58 {
  color: #1665d8;
  font-size: 12px;
  padding: 20px 24px 0 24px;
  position: relative;
  cursor: pointer;
}
._toggleMore_1agty_58:after {
  content: "";
  position: absolute;
  right: 0;
  height: 5px;
  width: 8px;
  background-image: url("/dist/icons/chevron-blue-up.svg");
  background-position: center;
  background-size: cover;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  